// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"514":"f428bde1","529":"68b025ab","708":"0b4960d4","810":"a9c778eb","840":"91be0646","914":"c20d2a44"}[chunkId] + ".chunk.css";
};